import { render } from "./UndesiredModulesModal.vue?vue&type=template&id=7cd91439"
import script from "./UndesiredModulesModal.vue?vue&type=script&lang=js"
export * from "./UndesiredModulesModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__